function getTop() {
    return jQuery(this).scrollTop();
}

window.console.zagInfo = function ( message ) {
    return console.log( '%c ' + message , 'background: #222; color: #bada55');
};

function addBrowserTypeToWindow() {
    jQuery.uaMatch = function( ua ) {
        ua = ua.toLowerCase();
        var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
            /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
            /(msie) ([\w.]+)/.exec( ua ) ||
            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) || [];
        return {
            browser: match[ 1 ] || "",
            version: match[ 2 ] || "0"
        };
    };
    if ( !jQuery.browser ) {
        var
            matched = jQuery.uaMatch( navigator.userAgent ),
            browser = {};
        if ( matched.browser ) {
            browser[ matched.browser ] = true;
            browser.version = matched.version;
        }
        // Chrome is Webkit, but Webkit is also Safari.
        if ( browser.chrome ) {
            browser.webkit = true;
        } else if ( browser.webkit ) {
            browser.safari = true;
        }
        jQuery.browser = browser;
    }
}

function hasTouch() {
    addBrowserTypeToWindow();
    return jQuery.browser.device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
}

function addTouch() {
    var html = jQuery('html');
    if ( hasTouch() ) {
        html.removeClass('no-touch');
        html.addClass('touch');
    } else {
        html.removeClass('touch');
        html.addClass('no-touch');
    }
}

function doSwipe(el) {
    if( $(el).length > 0 ) {
        $(el).swipe({
            swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
                if (direction == 'left') $(this).carousel('next');
                if (direction == 'right') $(this).carousel('prev');
            },
            allowPageScroll:"vertical"
        });
    }
}

// Add resize with timeout to jQuery obj
if (window.jQuery) {
    $.fn.resized = function (callback, timeout) {
        $(this).resize(function () {
            var $this = $(this);
            if ($this.data('resizeTimeout')) {
                clearTimeout($this.data('resizeTimeout'));
            }
            $this.data('resizeTimeout', setTimeout(callback, timeout));
        });
    };

    $.fn.toggleClassActive = function () {
        $(this).toggleClass('active');
    };

    $.fn.removeClassActive = function () {
        $(this).removeClass('active');
    };

    $.fn.animatedToggleFadeIn = function () {
        $(this).toggleClass('animated fadeIn');
    };

    $.fn.animatedRemove = function ( css ) {
        $(this).removeClass('animated ' + css);
    };

    $.fn.animatedRemoveFadeIn = function ( ) {
        $(this).animatedRemove('animated fadeIn');
    };


}

$(window).bind('orientationchange resize', function(event){
    if(event.orientation) {
        if(event.orientation == 'portrait') {
            // do something
        } else if (event.orientation == 'landscape') {
            // do something else
        }
    } else {
        // optional... PC-version javascript for example
    }
});

/**
 * LightGallery init
 * ------------------------------
 */
function GornitzkyLightgallery(el) {
    /**
     *
     */
    this.el = el;

    /**
     *
     * @returns {*|jQuery|HTMLElement}
     */
    this.getEL = function () {
        return $(this.el);
    };

    /**
     *
     */
    this.lightGallery = function () {
        this.getEL().lightGallery({
            pager: true
        });
    };

    /**
     *
     */
    this.init = function () {
        var self = this;
        self.lightGallery();
    };

    return this.init();
}

/**
 * Search init
 * ------------------------------
 */
function doSearch() {

    this.html = $('html');
    this.body = $('body');

    this.animate = function () {
        $("html, body").animate({scrollTop: 0}, 0);
    };

    this.searchIsOpen = function () {
        return this.html.hasClass('search-open')
    };

    this.closeSearch = function () {
        this.html.removeClass('search-open');
        var self = this;
        setTimeout(function() {
            self.html.removeClass('search-opened');
        }, 600);
    };

    this.openSearch = function () {
        return this.html.addClass('search-open').addClass('search-opened');
    };

    this.init = function () {
        var selfSearch = this;
        selfSearch.animate();
        if( selfSearch.searchIsOpen() ) { //I want to close the search
            selfSearch.closeSearch();
            return;
        }
        selfSearch.openSearch();
        this.body.find('.part-search-form .search-form .search-input').delay(500).focus();
    };

    return this.init();
}


jQuery(document).ready(function ($) {

    // Check if its mobile
    addTouch();

    /**
     * Close all modals in keydown Esc event
     */
    $(document).keydown(function(event) {
        if (event.keyCode === 27 && $('body').hasClass('modal-open')) {
            $('.modal').modal('hide');
        }
    });

    /**
     * Carousel Swipe for mobile
     * ------------------------------
     */
    if( window.innerWidth <= 991 )
        doSwipe('.part-quote-carousel');

    var elements = {};
    elements.header = $('header.site-header');
    elements.navbarToggle = elements.header.find('.navbar-toggle');
    elements.mainMenuLi = elements.header.find('.primary-menu > ul > li');
    elements.dropdownToggle = elements.header.find('.dropdown-toggle');
    elements.overlay = $('body > .overlay');
    elements.dropdownMenu = elements.header.find('.dropdown-menu');
    elements.dropdownMenuPractices = elements.header.find('.full-screen .dropdown-menu');
    elements.searchDropdownMenu = elements.header.find('.search .dropdown-menu');
    elements.masthead = $('body > main > .masthead');
    elements.main = $('body > main');
    elements.mobileMenuWrap = elements.header.find('.mobile-menu-wrap');
    /**
     * Check if the header has class active
     * @returns {*|boolean}
     */
    elements.headerIsActive = function () {
        return elements.header.hasClass('active');
    };

    /**
     * Get the header outerHeight
     * @returns {*}
     */
    elements.getHeaderHeight = function () {
        return  elements.header.outerHeight(true);
    };

    /**
     * Add style top to the dropdown menu
     * @param {bool} removeHeight
     */
    elements.setDropdownMenuTop = function (removeHeight) {
        var height = removeHeight ? '' : elements.getHeaderHeight();
        elements.dropdownMenu.css({
            'top': height + 'px'
        });
    };

    elements.setDropDownMenuPracticesHeight = function (  ) {
        var numberOfItems = Math.ceil(elements.dropdownMenuPractices.find('> li').length);
        var numberofRows = Math.ceil(numberOfItems /  3);
        var css = "<style>@media (min-width: 992px) {";
        for(var i = 1; i <= numberofRows; i++) {
            css += "header.site-header .bottom .bottom-menu-right-parent .bottom-menu-right .primary-menu>ul li.dropdown.full-screen>.dropdown-menu>li:nth-child("+numberofRows+"n+"+i+") { order: "+i+"; }";
        }
        css += "}</style>";
        $('head').append(css);

        if(numberOfItems % 3 == 1) {
            elements.dropdownMenuPractices.append('<li></li>')
        }

    };

    /**
     * Add style top to header search dropdown
     * @param {bool} removeHeight
     */
    elements.setSearchDropdownMenuTop = function (removeHeight) {
        var height = removeHeight ? '' : elements.getHeaderHeight();
        elements.searchDropdownMenu.css({
            'top': height + 'px'
        });
    };

    /**
     * Add style top to header .mobile-menu-wrap
     * @param {bool} removeHeight
     */
    elements.setMobileMenuWrapTop = function (removeHeight) {
        var height = removeHeight ? '' : elements.getHeaderHeight();
        elements.mobileMenuWrap.css({
            'top': height + 'px'
        });
    };

    // Add style top to the dropdown menu
    elements.setDropdownMenuTop();

    elements.setDropDownMenuPracticesHeight();

    // Add style top to header search dropdown
    elements.setSearchDropdownMenuTop();

    // Add style top to the .mobile-menu-wrap
    elements.setMobileMenuWrapTop();

    $(window).bind('orientationchange resize', function(event){
        if( window.innerWidth >= 992 ) {
            elements.overlay.removeClass('in');
            if( elements.headerIsActive() )
                elements.header.removeClassActive();

            // Add style top to the dropdown menu according to the resize window
            elements.setDropdownMenuTop();

        }else  {
            // Remove the style top from the dropdown menu
            elements.setDropdownMenuTop( true );
        }

        // Add style top to header search dropdown according to the resize window
        elements.setSearchDropdownMenuTop();

        // Add style top to the .mobile-menu-wrap
        elements.setMobileMenuWrapTop();
    });

    /**
     * Menu navbar toggle
     * ------------------------------
     */
    elements.navbarToggle.click(function (e) {
        e.preventDefault();
        elements.header.toggleClassActive();
    });


    // Team search
    (function () {
        var searchPanel = $('.search-members-panel'),
            form = searchPanel.find('.part-search-members'),
            letters = searchPanel.find('.part-search-members-letters'),
            letter, letterInput, member, practice, role, submit;
        if( form.length > 0 && letters.length > 0) {
            submit = form.find('[type="submit"]');
            letter = letters.find('ul > li a');
            letterInput = form.find('[name="letter"]');
            member = form.find('[name="member"]');
            practice = form.find('[name="practice"]');
            role = form.find('[name="role"]');
            letter.on('click', function (e) {
                e.preventDefault();
                var self = $(this),
                data = self.data('letter');
                if( self.parent().hasClass('active') ) letterInput.val('');
                else letterInput.val( data );
                member.val('');
                form.submit();
            });

            practice.on('change', function(e) {
                form.submit();
            });

            role.on('change', function(e) {
                form.submit();
            });

            submit.on('click', function (e) {
                if( member.val().trim() !== '' ) {
                    letterInput.val('');
                    practice.val('');
                    role.val('');
                }
            });
        }
    })();

    (function () {
        var accordion = {};
        accordion.collapse = $('.part-accordion .collapse');
        accordion.toggle = function (self) {
            self = self.parent().find('[data-toggle="collapse"] span.fa');
            var panel = self.closest('.panel');
            panel.toggleClass('open');
            if( self.hasClass('fa-plus') ) {
                self.removeClass('fa-plus').addClass('fa-minus');
                return;
            }
            self.removeClass('fa-minus').addClass('fa-plus');
        };

        // The collapsible content is about to be shown
        accordion.collapse.on('show.bs.collapse', function(){
            accordion.toggle($(this));
        });

        // The collapsible content is now fully shown
        accordion.collapse.on('shown.bs.collapse', function(){
            if( window.innerWidth >= 992 )
                $(this).find('> .panel-body').focus();
        });

        // The collapsible content is about to be hidden
        accordion.collapse.on('hide.bs.collapse', function(){
            accordion.toggle($(this));
        });
    })();

    $(window).on('scroll', function (event) {
        var self = $(this),
            st = self.scrollTop();

        if (getTop() === 0)
            elements.header.removeClass('scroll');
        else
            elements.header.addClass('scroll');
    });


    /**
     * Counter Slider
     */
    $('.counter-slider .slider').slick({
        slide: '.slider-item',
        arrows: false, // Enable Next/Prev arrows
        fade: true, // Enables fade
        autoplay: true, // Enables auto play of slides
        swipe: false, // Enables touch swipe
        touchMove: false, // Enables slide moving with touch
        draggable: false, // Enables desktop dragging
        pauseOnFocus: false, // Pauses autoplay when slider is focussed
        pauseOnHover: false, // Pauses autoplay on hover
        cssEase: 'linear',
        autoplaySpeed: 6000,
        speed: 1000,
        rtl: gornitzkyIsRtl()
    });

    /**
     * Slide Article
     */
    $('.slide-article .btn').on('click', function (e) {
        e.preventDefault();
        var self = $(this),
            wrap = self.closest('.slide-article').find('.articles-wrap');
        if (wrap.hasClass('hide')) {
            wrap.removeClass('hide').hide().slideDown('slow', function () {
                if (window.innerWidth <= 991) self.parent().remove()
            });
        }
    });


    /**
     * CF7 Events
     * ----------
     */

    /* Validation Events for changing response CSS classes */
    /*
    document.addEventListener('wpcf7invalid', function (event) {
        var elemnts = {};
        elemnts.parent = $(event.detail.apiResponse.into);
        console.log(event)
        elemnts.output = elemnts.parent.find('.wpcf7-response-output').detach();
        $(elemnts.output).insertAfter(elemnts.parent.find('.wpcf7-form'));

    }, false);

    document.addEventListener('wpcf7spam', function (event) {
        console.log('wpcf7spam')
    }, false);

    document.addEventListener('wpcf7mailfailed', function (event) {
        console.log('wpcf7mailfailed')
    }, false);

    document.addEventListener('wpcf7mailsent', function (event) {

    }, false);

    document.addEventListener('wpcf7:submit', function (event) {
        var part = $(this).closest('.part-form-events')
        part.find('.wpcf7-response-output').remove();
    }, false);
*/

    /**
     * Change country select input in the Alumni tamplate
     */
    /*(function () {
        var country = $('.wpcf7-form [name="country"]');
        if (country.length > 0 && typeof getGornitzkyCountries === 'function') {
            var countries = getGornitzkyCountries(), output, options = [];
            $.each(countries, function (key, obj) {
                if( obj.code === 'IL' || obj.code === 'US' ) {
                    output = '<option value="';
                    output += obj.name;
                    output += '" ';
                    output += obj.code === 'IL' ? 'selected' : '';
                    output += '>';
                    output += obj.name;
                    output += '</option>';
                    options.push(output);
                }
            });
            country.html(options.join(''));
        }
    })();
    */

    /**
     * LightGallery init
     * ------------------------------
     */
    new GornitzkyLightgallery('#lightgallery');

    /**
     * Search
     * ------------------------------
     */
    $('.search-button a').on('click', function (e) {
        e.preventDefault();
        new doSearch();
    });

    $('body').on('click', '.part-search-form .search-close', function (e) {
        e.preventDefault();
        new doSearch();
    });

    $(document).keyup(function (e) {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
            if ($('html').hasClass('search-open')) {
                new doSearch();
            }
        }
    });

    $('body').on('submit', '.search-form', function (e) {
        var input = $(this).find('.search-input');
        if( input.val().trim() === '' ) e.preventDefault();
    });

    /**
     * Accordion
     * ------------------------------
     */
    (function () {
        var collapse = $('.part-accordion .accordion-panel .accordion-collapse'),
            removeOpen = function (partAccordion) {
                partAccordion.find('.accordion-panel.open').removeClass('open');
            };
        collapse.on('show.bs.collapse', function () {
            var self = $(this);
            removeOpen(self.closest('.part-accordion'));
            self.closest('.accordion-panel').addClass('open');
        });
        collapse.on('hide.bs.collapse', function () {
            removeOpen($(this).closest('.part-accordion'));
        });
    })();

    /**
     * Newsletter
     * ------------------------------
     */
    $('.show-newsletter-modal').on('click', function (e) {
        e.preventDefault();
        $('#newsletterModal').modal('show')
    });

    /**
     * Media center search select in mobile
     * ------------------------------
     */
    $('.media-center-mobile-search #searchInMediaCenter').on('change', function (e) {
        var self = $(this),
            link = self.val().trim();
        if( link.length > 0 )
            window.location.href = link;
    });

    /**
     * Back to top
     * ------------------------------
     */
    $('.back-to-top .item').on('click', function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });


    /**
     * Newsletter modal select all
     */
    $('form.wpcf7-form .newsletter-select-all').on('change', function (e) {
        var _this = $(this),
            specialCheckboxes = _this.closest('form.wpcf7-form').find('.special-checkboxes');

        specialCheckboxes.find('input[type="checkbox"]').each( function () {
            var self = $(this);
            if( !self.is('checked') )
                self.prop('checked', true);
        })
    })

});







